import { render } from "./TraderCmsPage.vue?vue&type=template&id=dceb370c"
import script from "./TraderCmsPage.vue?vue&type=script&lang=js"
export * from "./TraderCmsPage.vue?vue&type=script&lang=js"

import "./TraderCmsPage.vue?vue&type=style&index=0&id=dceb370c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__